export const REGEX_PATTERNS = {
  EMAIL: /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}(?:\.[A-Z]+)?$/i,
  PHONE: /^(1\s?)?(\(\d{3}\)|\d{3})([\s-])?\d{3}([\s-])?\d{4}$/,
  REMOVE_WHITE_SPACE: /\s{2,}/g,
};

// Url to redirect from sticky Ship Now button
export const SHIP_NOW_URL = 'https://shipment.xpressbees.com/';
